import React, { Component } from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import uuid from "uuid";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import actions from "redux-form/lib/actions";
import $ from "jquery";

import Image from "../../../component/Image";
import { price, getImageUrl } from "../../../lib/utils";

/**
 * ExtraProductBox
 */
class ExtraProductBox extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    formArrayPush: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(Immutable.Map).isRequired,
    cartItemIndex: PropTypes.number.isRequired,
    cartItem: PropTypes.shape({
      extraProducts: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          quantity: PropTypes.number.isRequired
        })
      )
    }).isRequired
  };

  static defaultProps = {};

  state = {
    adding: false
  };

  // shouldComponentUpdate(nextProps) {
  //   // for some reason this does not work in the connect() "areMergedPropsEqual" option
  //   return !isEqual(this.props, nextProps);
  // }

  onAddExtraProduct = e => {
    if (e.keyCode && e.keyCode !== 13) {
      return true;
    }
    this.setState({ adding: true });

    setTimeout(() => {
      const { cartItemIndex } = this.props;

      const id = this.props.product.get("id");

      if (this.props.cartItem.extraProducts.indexOf(id) === -1) {
        this.props.formArrayPush("cart", `items[${cartItemIndex}].extraProducts`, {
          uuid: uuid(),
          id,
          quantity: 1
        });
      }
      $(window).trigger("debloemist.cart.updated");
      this.setState({ adding: false });
    }, 300);

    return false;
  };

  render() {
    const { t, product } = this.props;

    const imageUrl = getImageUrl({
      id: product.get("imageId"),
      imageVersionId: product.get("imageVersionId"),
      width: 150,
      height: 150
    });

    const discount = product.get("discount", 0);
    return (
      <div className="Cart__Step1__ExtraProductBox">
        <div className="Cart__Step1__ExtraProductBox__Card">
          <div className="Cart__Step1__ExtraProductBox__Card__Overlay">
            <Image src={imageUrl} />
            <div className="Cart__Step1__ExtraProductBox__Card__Overlay__Title">
              {this.state.adding ? <i className="fa fa-spin fa-circle-notch" /> : product.get("title")}
            </div>
          </div>
          <div className="Cart__Step1__ExtraProductBox__Card__Price center">
            {discount > 0 && (
              <span>
                <span className="strikethrough">{price(product.get("priceEx") * product.get("taxMultiplier"))}</span>
                <span> {t("now")}&nbsp;</span>
              </span>
            )}
            <span className="bold">{price(product.get("priceEx") * product.get("taxMultiplier") - discount)}</span>
          </div>
          <button
            disabled={this.state.adding}
            className="btn btn-primary"
            type="button"
            onClick={this.onAddExtraProduct}
          >
            {this.state.adding ? <i className="fa fa-spin fa-circle-notch" /> : t("Add")}
          </button>
        </div>
      </div>
    );
  }
}

export default translate()(
  connect(
    null,
    {
      formChange: actions.change,
      formArrayPush: actions.arrayPush
    }
  )(ExtraProductBox)
);
